export const EMPTY_PROPERTY_VALUE = '--';